import React from 'react';
import styled from '@emotion/styled';
import Page from '../../../components/Page/Page';
import PageBanner from '../../../components/Banner/PageBanner';
import SettingsSegment from './SettingsSegment';

const Settings = () => {
  return (
    <Page title="Locum Health | Your Jobs">
      <Container>
        {' '}
        <PageBanner
          label="Settings"
          description="Welcome to your settings dashboard"
        />
        <SettingsSegment />
      </Container>
    </Page>
  );
};

export default Settings;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  padding-left: 2rem;
  padding-right: 2rem;


  @media (max-width: 480px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
